<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import autofit from 'autofit.js'
export default {
  name: 'App',
  components: {
    
  },
  mounted(){
    autofit.init({
    dh: 1080,
    dw: 1920,
    el: '#app',
    resize: true
  })
  }
}
</script>

<style>

body,html,#app{
  width: 100%;
  height: 100%;
};

</style>
